var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcActionBgShapeOctagon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.29412 2H16.7059L22 7.29412V16.7059L16.7059 22H7.29412L2 16.7059V7.29412L7.29412 2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcActionBgShapeOctagon);
export default __webpack_public_path__ + "static/media/ic_action_bg_shape_octagon.7bd73f89f4428c9b5c8e778bd33b2f7c.svg";
export { ForwardRef as ReactComponent };